import { apiClient } from './api'

export interface NocDeviceRow {
  id: string
  name: string
  serial_number: string
  device_type: string
  status: string
  battery_level?: string | null
  last_seen?: string | null
  lat?: number | null
  long?: number | null
  orbcomm_modem?: boolean
}

export interface NocRecentActivity {
  id: string
  first_name?: string | null
  last_name?: string | null
  email?: string | null
  last_action?: string | null
}

export interface NocSummary {
  // Sessions card
  sessions_7d: number
  sessions_trend_pct: number

  // Orbcomm card
  orbcomm_active: number
  orbcomm_inactive: number

  // Low battery card
  low_battery_devices: number

  // Devices card
  devices_online_24h: number
  devices_with_gps: number
  deployed_devices: number
  devices_total: number

  // Missing transmissions card
  missing_transmissions: {
    '24h': number
    '3d': number
    '7d': number
    '30d': number
  }

  // Failed sensors card
  failed_sensors: number

  // Extras
  total_users: number
  total_accounts: number
  active_alerts: number
  user_trend_7d_pct: number

  device_breakdown: Array<{
    device_type: string
    count: number
  }>

  // Tables & map
  devices: NocDeviceRow[]
  recent_activity: NocRecentActivity[]
}

export const adminService = {
  getNocSummary: async (): Promise<NocSummary> => {
    const { data } = await apiClient.get<NocSummary>('/admin/noc-summary')
    return data
  },

  impersonateUser: async (userId: string): Promise<{ token: string; user: any }> => {
    const { data } = await apiClient.post(`/admin/impersonate/${userId}`)
    return data
  },
}
